import type { BootPhase } from '@/features/auth/useBoot'
import { Brand } from '@/components/shared/Brand'
import { DsBadge, DsEmptyState, DsIcons, DsSplashIllustration } from '@/ds'
import { bootStrings } from '@/features/auth/strings'

interface Props {
  phase: BootPhase
  onRetry?: () => void
}

export function BootScreen({ phase, onRetry }: Props) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-gutter text-center" style={{ backgroundImage: 'radial-gradient(circle at 50% 35%, var(--brand-soft), var(--background) 70%)' }} role="status" aria-live="polite" aria-label={phase === 'loading' ? bootStrings.loading : undefined}>
      <Brand size="lg" />
      {phase === 'loading' && (
        <div className="flex flex-col items-center gap-4 animate-ds-scale-in">
          <DsSplashIllustration semanticLabel={bootStrings.illustration} size={200} />
          <DsBadge label={bootStrings.tagline} tone="brand" variant="outline" size="md" icon={DsIcons.shield} />
        </div>
      )}
      {phase === 'offline' && <DsEmptyState.Offline title={bootStrings.offlineTitle} description={bootStrings.offlineDescription} actionLabel={bootStrings.tryAgain} onAction={onRetry} />}
      {phase === 'error' && <DsEmptyState.Error title={bootStrings.errorTitle} description={bootStrings.errorDescription} actionLabel={bootStrings.tryAgain} onAction={onRetry} />}
    </div>
  )
}
